/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
import 'react-chat-widget-t/lib/styles.css';
import { PropTypes } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  addResponseMessage, renderCustomComponent,
} from 'react-chat-widget-t';
import Cards from './components/Cards/Cards';
import Carousel from './components/Carousel/Carousel';
import { EVENT_WELCOME } from './contants';
import logo from './logo.svg';
import './App.css';
import { keyExist } from './utils';

import { updateWebhook, updateTestMode } from './services/message/actions';
import Webwidget from './components/Webwidget/Webwidget';
import { sendTextMessage } from './components/Webwidget/actions';
import Error from './pages/Error';

function App(props) {
  const [webhook, setWebhook] = useState('');
  const [title, setTitle] = useState('Delight Chat Bot');
  const [subtitle, setSubtitle] = useState('');
  const [isTest, setIsTest] = useState(false);

  const getURLParams = () => {
    const { search } = window.location;
    return new URLSearchParams(search);
  };

  const postMessage = (event) => {
    const WELCOME_TYPE = 'welcome';

    try {
      const jsonData = JSON.parse(event.data);
      const { type, data } = jsonData;
      switch (type) {
        case 'text':
          if (typeof data === 'string') {
            addResponseMessage(data);
          }
          break;
        case 'card':
          renderCustomComponent(Cards, data);
          break;
        case 'carousel':
          renderCustomComponent(Carousel, { items: data });
          break;
        case 'event':
          if (typeof data === 'string') {
            /**
             * first time to trigger widget
             * send a welcome request to server
             * to get default welcome message
             */
            if (data.toLowerCase() === EVENT_WELCOME) {
              props.sendTextMessage('Hello');
            }
          }
          break;
        default:
          console.warn('unsupported UI type');
      }
    } catch (err) {
      console.error(err);
    }
  };

  const initParams = () => {
    const params = getURLParams();
    const key = params.get('key');
    // eslint-disable-next-line no-underscore-dangle
    const title_ = params.get('title');
    const subtitle_ = params.get('subtitle');
    const isTest_ = params.get('test');

    if (keyExist(key)) {
      setWebhook(key);
      props.updateWebhook(key);
    }
    if (keyExist(title_)) {
      setTitle(title_);
    }
    if (keyExist(subtitle_)) {
      setSubtitle(subtitle_);
    }
    if (keyExist(isTest_)) {
      setIsTest(isTest_ === 'true');
      props.updateTestMode(isTest_ === 'true');
    }
  };

  useEffect(() => {
    // handlePostMessage();
    window.addEventListener('message', postMessage);
    initParams();
    return () => {
      window.removeEventListener('message', postMessage);
    };
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        {webhook === ''
          ? (
            <Error
              isTest={isTest}
            />
          )
          : (
            <Webwidget
              title={title}
              webhook={webhook}
              subtitle={subtitle}
              isTest={isTest}
            />
          )}
      </header>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    sendTextMessage,
    updateWebhook,
    updateTestMode,
  }, dispatch);
}

const withConnect = connect(
  null,
  mapDispatchToProps,
);

App.propTypes = {
  sendTextMessage: PropTypes.func.isRequired,
  updateWebhook: PropTypes.func.isRequired,
  updateTestMode: PropTypes.func.isRequired,
};

export default compose(
  withConnect,
)(App);
